import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface RebuildBrandCatalogRequest {
    companyId: string;
}

interface RebuildBrandCatalogResponse {
    companyId: string;
}

const rebuildBrandCatalog = async (
    companyId: string,
): Promise<RebuildBrandCatalogResponse> => {
    const fn = httpsCallable<RebuildBrandCatalogRequest, RebuildBrandCatalogResponse>(
        functions,
        'handle_rebuild_brand_catalog',
    );
    const result = await fn({ companyId });
    return result.data;
};

export { rebuildBrandCatalog };
